import { Directive, Output, HostListener, ElementRef, EventEmitter, Input } from '@angular/core';

@Directive({
  selector: '[appOuterClick]'
})
export class OuterClickDirective {

  @Output() outsideClick = new EventEmitter<MouseEvent>(); 
  @Input() appOuterClick:any;

  constructor(private readonly elementRef: ElementRef) {}
 
  @HostListener('document:click', ['$event'])
  public onDocumentClick(event: MouseEvent): void {
    const targetElement = this.getEventTargetElement(event?.target, event);
    if (!targetElement) return;

    // Advanced Search modal should not be considered an outside-click target.
    // It may be rendered outside the navbar container in the DOM.
    const advEl = document.getElementById('adv');
    if (advEl?.contains(targetElement) || targetElement.closest('.advance-search')) return;
    const composedPathFn = (event as any)?.composedPath;
    const path = typeof composedPathFn === 'function' ? composedPathFn.call(event) : [];
    if (advEl && Array.isArray(path) && path.includes(advEl)) return;
    if (Array.isArray(path) && path.some((n: any) => n instanceof HTMLElement && (n.id === 'adv' || n.classList?.contains('advance-search')))) return;

    // Ignore clicks inside PrimeNG overlays (dropdown panels, datepicker, overlay panels, etc.).
    // Many components append overlays to <body>, which would otherwise look like an "outside click".
    if (this.isPrimeNgOverlayInteraction(targetElement, event)) return;

    // Check if the click was outside the element
    if (!this.elementRef.nativeElement.contains(targetElement)) {
      this.outsideClick.emit(event);
    }
  }

  private getEventTargetElement(target: any, event?: any): HTMLElement | null {
    if (target instanceof HTMLElement) return target;
    if (target?.nodeType === 3 && target.parentElement instanceof HTMLElement) return target.parentElement;
    if (target?.parentElement instanceof HTMLElement) return target.parentElement;

    // Fallback: composedPath can contain the real element for shadow DOM / retargeted events
    const path = typeof event?.composedPath === 'function' ? event.composedPath() : [];
    if (Array.isArray(path)) {
      for (const node of path) {
        if (node instanceof HTMLElement) return node;
      }
    }
    return null;
  }

  private isPrimeNgOverlayInteraction(target: HTMLElement, event?: any): boolean {
    const selectors = [
      '.p-dropdown-panel',
      '.p-overlay',
      '.p-overlaypanel',
      '.p-connected-overlay',
      '.p-component-overlay',
      '.p-datepicker',
      '.p-calendar',
      '.p-tooltip',
      '.p-dropdown-item',
      '.p-dropdown-items',
      '.p-dropdown-items-wrapper',

      // Older PrimeNG/PrimeUI classnames
      '.ui-dropdown-panel',
      '.ui-overlaypanel',
      '.ui-datepicker',
      '.ui-calendar',
      '.ui-tooltip',
      '.ui-widget-overlay',
      '.ui-dropdown-item'
    ];

    if (selectors.some((sel) => !!target.closest(sel))) return true;

    const path = typeof event?.composedPath === 'function' ? event.composedPath() : [];
    if (!Array.isArray(path) || path.length === 0) return false;
    for (const node of path) {
      if (!(node instanceof HTMLElement)) continue;
      if (selectors.some((sel) => !!node.closest(sel))) return true;
    }
    return false;
  }
}
